import React from 'react'

const Input = ({ type, placeholder, value, onChange, label, id, name, error = false, errorMessage = '', required = false, onBlur }) => {
  return (
    (type === 'textarea') ? (
        <div className='flex flex-col gap-2'>
            <label className='text-sm font-medium px-1 text-primary' htmlFor={id}>
              {label}{required ? <span className='text-red-600'> *</span> : null}
            </label>
            <div className={`w-full bg-white rounded-md border ${error ? 'border-red-500' : 'border-gray-300'} p-2`}>
                <textarea className='w-full bg-transparent outline-none text-primary' id={id} placeholder={placeholder} value={value} onChange={onChange} onBlur={onBlur} name={name} />
            </div>
            {errorMessage ? <p className='text-red-600 text-xs px-1'>{errorMessage}</p> : null}
        </div>
    ) : (
    <div className='flex flex-col gap-2'>
        <label className='text-sm font-medium px-1 text-primary' htmlFor={id}>
          {label}{required ? <span className='text-red-600'> *</span> : null}
        </label>
        <div className={`w-full bg-white rounded-md border ${error ? 'border-red-500' : 'border-gray-300'} p-2`}>
            <input className='w-full bg-transparent outline-none text-primary' id={id} type={type} placeholder={placeholder} value={value} onChange={onChange} onBlur={onBlur} name={name} />
        </div>
        {errorMessage ? <p className='text-red-600 text-xs px-1'>{errorMessage}</p> : null}
    </div>
    )
  )
}

export default Input